import type { ModuleKey } from '@/access/modules';

export type MeBranch = {
  id: string;
  name: string;
};

export type Me = {
  employeeId: string;
  firstName: string;
  lastName: string;
  phone: string;
  email: string | null;
  avatarPath: string | null;
  birthDate: string | null;
  startDate: string | null;
  jobTitle: string | null;
  roleName: string;
  scope: 'self' | 'own_branch' | 'all_branches';
  primaryBranchId: string | null;
  branches: MeBranch[];
  /** מפתחות הרשאה. הבדיקה בקוד היא תמיד לפי מפתח, לא לפי שם תפקיד. */
  permissions: string[];
  /** המודולים הפעילים, כפי שהם ב app_settings ברגע הכניסה. */
  modules: Record<ModuleKey, boolean>;
};

export const fullName = (me: Me) => `${me.firstName} ${me.lastName}`.trim();
